module.exports = "<div class=\"days-header-container\">\n  <div class=\"dn {{day}}\"ng-repeat=\"day in $ctrl.dayNameArray track by $index\">{{day}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHeader/calendarInlineHeader.html
// module id = 1476
// module chunks = 0